import { array, option } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { ChargeablePreauthorization, PreauthorizationUsage } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { localizeCurrencyValue } from '@mews-commander/utils';
import { getNonZeroCurrencyValue } from '../../../../helpers/getNonZeroCurrencyValue';

export const hasMultipleGateways = flow(
    array.filter((usage: PreauthorizationUsage) => !!usage.gatewayType),
    array.size,
    (size) => size > 1
);

export const getFormIntialValues = (
    chargeablePreauthorizations: ChargeablePreauthorization[],
    preauthorizationId: string
) => {
    const { id, amount } = pipe(
        option.fromNullable(chargeablePreauthorizations),
        option.flatMap(array.findFirst((preauthorization) => preauthorizationId === preauthorization.id)),
        option.fold(
            () => chargeablePreauthorizations[0],
            (preauthorization) => preauthorization
        )
    );
    return {
        preauthorizationId: id,
        amount: getNonZeroCurrencyValue(amount.value, amount.currencyCode),
    };
};

export const getFormOptions = flow(
    array.map(({ label, id }: ChargeablePreauthorization) => ({ label, value: id })),
    array.map(createOption)
);

export const getSelectedPreauthorizationAmount = (
    chargeablePreauthorizations: ChargeablePreauthorization[],
    preauthorizationId: string
) =>
    pipe(
        chargeablePreauthorizations,
        array.findFirst((preauthorization) => preauthorization.id === preauthorizationId),
        option.fold(
            () => null,
            ({ amount }) =>
                localizeCurrencyValue({ value: amount.value, currency: amount.currencyCode }, { showSymbol: false })
        )
    );
